<template>
  <div :class="['tp-notification']">
    <div class="tp-notification-box" @click="handlerClick">
      <div class="tp-notification-left" v-if="showIcon">
        <fl-avatar :src="avatar" :nickname="mText" :size="36" ref="avatar" v-if="type && type === 'group'" />
        <fl-avatar
          :src="avatar"
          :nickname="mText"
          :size="36"
          ref="avatar"
          :fleet-id="driverId"
          v-else></fl-avatar>
      </div>
      <div class="tp-notification-info" v-else></div>
        <div class="tp-notification-header">
          <div class="tp-notification-content">
            <div class="tp-notification-header">
              <div class="tp-notification-title">{{mText}}</div>
            </div>
            <div class="tp-notification-message">{{message}}</div>
            <div class="tp-notification-button" v-if="showBtn">
              <common-button size="small" type="primary" @click.stop="handlerOk">REFRESH</common-button>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import FlAvatar from "../../fleet-element/packages/avatar/src/main";
export default {
  components: {FlAvatar},
  data() {
    return {
      showBtn: false,
      random: '',
      name: '',
      // closeTime: 3000,
      // basicCloseTime: 3000,
      closeTime: 3000000,
      animateTime: 500,
      setTimeId: null,
      setTimeAnimateId: null,
      message: '',
      driverId: 0,
      account: '',
      title: '',
      type: '',
      avatar: '',
      showIcon: true,
      init: true,
      hideList: [
        /^\/login(\/.*)?$/,
        /^\/feedback(\/.*)?$/,
        /^\/scan-document(\/.*)?$/,
        /^\/shareTrack(\/.*)?$/,
      ]
    }
  },
  computed: {
    mText() {
      return this.title || ''
    },
  },
  watch: {
    random() {
      if (this.paramsCloseTime) {
        this.closeTime = this.paramsCloseTime
        this.paramsCloseTime = null
      } else {
        this.closeTime = this.basicCloseTime
      }
      this.setTimeId && clearTimeout(this.setTimeId)
      this.setTimer()
    },
    account:{
      handler() {
        if (this.account) {
          this.driverId = parseInt((this.account).split('-')[1])
        }
      },
      immediate: true
    }
  },
  methods: {
    handlerClick() {
      this.onClick && this.onClick()
    },
  },
  mounted() {
    setTimeout(() => {
      this.init = false
    }, 1000)
  }

}
</script>
<style lang="scss" scoped>
  .tp-notification{
    width: 350px;
    padding: 17px 16px 16px 16px;
    background: #fff;

    .el-notification__group{
      margin-left: 0;
      width: 100%;
      margin-right: 0;
    }
    .el-notification__content{
      margin-top: 0;
      display: flex;
    }

    .tp-notification-box{
      width: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
    }

    #tp-notification-mock{
      width: 95%;
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      opacity: 0;
      bottom: 0;
    }

    .tp-notification-left{
      width: 36px;
      height: 36px;
      color: #fff;
      border-radius: 50%;
      margin-right: 12px;
      position: relative;
    }
    .tp-notification-circle{
      overflow: hidden;
      border-radius: 50%;
      height: 100%;
      width: 100%;
      line-height: 31px;
      text-align: center;
    }
    .tp-notification-icon{
      height: 100%;
      border-radius: 50%;
    }

    .tp-notification-info{
      height: 24px;
      width: 24px;
      background: url("../../assets/img/notification/message.svg") no-repeat;
      align-self: flex-start;
      margin-right: 12px;
    }

    .tp-notification-number{
      position: absolute;
      top: 3px;
      right: 1px;
      z-index: 1;
      font-size: 12px;
      height: 16px;
      line-height: 16px;
      text-align: center;
      width: 16px;
      border-radius: 50%;
      background: red;
      transform: translate(50%, -50%);
    }
    .tp-notification-name{
      font-size: 12.4px;
      font-weight: bold;
    }
    .tp-notification-content{
      //margin-left: 11px;
      display: flex;
      flex-direction: column;
      width: 280px;
    }

    .tp-notification-message{
      font-size: 14px;
      color: #000000;
      font-weight: normal;
      font-stretch: normal;
      margin-top: 8px;
      width: 250px;
      overflow: hidden;
      text-overflow:ellipsis;
      // white-space: nowrap;
    }

    .tp-notification-title{
      color: #000000;
      font-weight: bold;
      font-stretch: normal;
      font-size: 18px;
      width: 250px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .tp-notification-header{
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

  }
  .tp-notification-button{
    display: flex;
    margin-top: 20px;
    align-items: center;
    justify-content: flex-end;
  }
</style>
